import React from 'react'
import { MutationFn } from 'react-apollo'
import { Link } from 'react-router-dom'
import { generateCreateUrl, getOnboardingPathSlug } from '#src/services/path'
import {
  StartExpertConsumerConversationMutation,
  StartExpertConsumerConversationComponent,
  StartExpertConsumerConversationMutationVariables
} from '#src/generated/graphql'
import Logger from '#src/services/logger'
import { toast } from 'react-toastify'
import { IdentityConsumer } from '#src/containers/Identity'
import { Route } from 'react-router-dom'

interface ExpertChatButtonProps {
  children: (
    startExpertConsumerConversation?: MutationFn<
      StartExpertConsumerConversationMutation,
      StartExpertConsumerConversationMutationVariables
    >,
    loading?: boolean
  ) => JSX.Element
  className?: string
  expertId?: string
  guestLocation?: string
}

const ExpertChatButton: React.SFC<ExpertChatButtonProps> = ({
  children,
  className,
  expertId,
  guestLocation = generateCreateUrl(getOnboardingPathSlug())
}) => {
  return (
    <Route
      render={({ history }) => (
        <IdentityConsumer>
          {({ myself }) => {
            if (!myself) {
              return (
                <Link to={guestLocation} className={className}>
                  {children()}
                </Link>
              )
            }

            if (expertId) {
              return (
                <StartExpertConsumerConversationComponent
                  onCompleted={response => {
                    if (
                      response &&
                      response.startExpertConsumerConversation &&
                      response.startExpertConsumerConversation.conversation
                    ) {
                      return history.push(
                        `/inbox/${response.startExpertConsumerConversation.conversation.id}`
                      )
                    } else {
                      Logger.captureException('Error starting conversation with expert', {
                        errorMessage: response.startExpertConsumerConversation.error
                      })

                      toast.error('Error starting conversation! Please try again.')
                    }
                  }}
                  variables={{
                    input: {
                      consumerId: myself.id,
                      expertId: expertId
                    }
                  }}
                >
                  {(startExpertConsumerConversation, { loading }) => {
                    return children(startExpertConsumerConversation, loading)
                  }}
                </StartExpertConsumerConversationComponent>
              )
            }

            // In the event we're logged in and an expert ID wasn't passed
            return (
              <Link to={guestLocation} className={className}>
                {children()}
              </Link>
            )
          }}
        </IdentityConsumer>
      )}
    />
  )
}

export default ExpertChatButton
